import clsx from 'clsx';
import { Column } from 'react-table';
import { useRecordTable } from '../../../hooks/useRecordTable';
import ModalBasicTableHeader from './ModalBasicTableHeader';
import ModalBasicTableBody from './ModalBasicTableBody';
import BasicTablePaginator from './BasicTablePaginator';

export type CustomColumn<T extends object> = Column<T> & {
  customCell?: (cell: any) => JSX.Element | string;
  className?: string;
};

interface ModalBasicTableProps<T extends object> {
  columns: CustomColumn<T>[];
  data: T[];
  actions?: (row: T) => any[];
  pageSize?: number;
  noDataMessage?: string;
  showFilters?: boolean;
  maxHeight?: string; // Altura máxima para el scroll vertical
}

const ModalBasicTable = <T extends object>({
  columns,
  data,
  actions,
  pageSize = 5,
  noDataMessage = 'No hay registros disponibles.',
  showFilters = false,
  maxHeight = 'max-h-[400px]',
}: ModalBasicTableProps<T>) => {
  const table = useRecordTable<T>({ columns, data, pageSize });

  return (
    <div className="w-full overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm dark:border-strokedark dark:bg-boxdark">
      {/* Tabla scrollable */}
      <div className="w-full overflow-x-auto">
        <div className={clsx('w-full', maxHeight, 'overflow-y-auto')}>
          <table
            {...table.getTableProps()}
            className="w-full min-w-[700px] table-auto border-collapse"
          >
            <ModalBasicTableHeader
              table={table}
              showFilters={showFilters}
              actions={actions}
            />
            <ModalBasicTableBody
              table={table}
              actions={actions}
              noDataMessage={noDataMessage}
            />
          </table>
        </div>
      </div>

      <BasicTablePaginator
        pageIndex={table.state.pageIndex}
        pageCount={table.pageCount}
        canPreviousPage={table.canPreviousPage}
        canNextPage={table.canNextPage}
        onPreviousPage={table.previousPage}
        onNextPage={table.nextPage}
      />
    </div>
  );
};

export default ModalBasicTable;
